<template>
  <filters
    v-if="pointStore.products.list !== null && pointStore.categories.list !== null && pointStore.depths.list !== null"
    :filter="filter"
    :products="products"
    :categories="categories"
    :depths="depths"
    @toggleSelected="toggleSelectedFilter"
    @toggleProduct="toggleSelectedProduct"
    @toggleDepth="toggleSelectedDepth"
    @toggleCategory="toggleSelectedCategory">
  </filters>

  <search-result
    v-if="pointStore.points !== null"
    :points="points"
    :enabledPoints="enabledPoints"
    :selectedPoint="selectedPoint"
    :search="search"
    :filter="filter"
    :searchResults="searchResults"
    :selectedProducts="selectedProducts"
    :selectedCategories="selectedCategories"
    :selectedDepths="selectedDepths"
    @togglePoint="togglePoint"
    @click="isOpen = true"
    @clearFilter="clearFilter"
    @marathon="marathon">
  </search-result>
</template>

<script setup>
import {usePointStore} from './store/store';
import {ref} from "vue";
import Filters from './components/filters.vue';
import SearchResult from './components/search-result.vue';

const pointStore = usePointStore();
const isOpen = ref(false);
pointStore.setInitialState();

function toggleSelectedFilter(object) {
  console.log(object);
  if (!object.disabled) {
    object.selected = !object.selected;
  }
}

function toggleSelectedProduct(product) {
  disableDepth(product);
  disableCategory(product);
  filterPoint();
}

function toggleSelectedCategory(category) {
  disableProductByCategory(category);
  filterPoint();
}

function toggleSelectedDepth(depth) {
  disableProductByDepth(depth);
  filterPoint();
}

function filterPoint() {
  //loop through points and check categories, depths and products and set disabled if one criterion doesn't match
  for (let i = 0; i < pointStore.points.length; i++) {
    let pointDisabled = false;
    let selectedProductsNumber = 0;
    for (let j = 0; j < pointStore.selectedProducts.length; j++) {
      selectedProductsNumber++;
      const productIndex = pointStore.points[i].products.findIndex(x => x.id === pointStore.selectedProducts[j].id);
      if (productIndex < 0) {
        pointStore.points[i].disabled = true;
        pointDisabled = true;
      } else {
        pointStore.points[i].disabled = false;
        pointDisabled = false;
        break;
      }
    }
    if (selectedProductsNumber === 0) {
      pointStore.points[i].disabled = false;
    }
    if (pointDisabled === false) {
      let selectedDepthsNumber = 0;
      for (let j = 0; j < pointStore.selectedDepths.length; j++) {
        selectedDepthsNumber++;
        if (pointStore.selectedDepths[j].maxDepth <= pointStore.points[i].maxDepth && pointStore.selectedDepths[j].maxDepth > pointStore.points[i].minDepth) {
          pointStore.points[i].disabled = false;
          pointDisabled = false;
          break;
        } else {
          pointStore.points[i].disabled = true;
          pointDisabled = true;
        }
      }
      if (selectedDepthsNumber === 0) {
        pointStore.points[i].disabled = false;
      }
      if (pointDisabled === false) {
        let selectedCategoriesNumber = 0;
        for (let j = 0; j < pointStore.selectedCategories.length; j++) {
          selectedCategoriesNumber++;
          const categoryIndex = pointStore.points[i].categories.findIndex(x => x.id === pointStore.selectedCategories[j].id);
          if (categoryIndex < 0) {
            pointStore.points[i].disabled = true;
            pointDisabled = true;
          } else {
            pointStore.points[i].disabled = false;
            pointDisabled = false;
            break;
          }
        }
        if (selectedCategoriesNumber === 0) {
          pointStore.points[i].disabled = false;
        }
      }
    }
    if (pointDisabled && pointStore.points[i].selected) {
      pointStore.points[i].selected = false;
    }
  }
}

function disableDepth(product) {
  const depthIndex = pointStore.depths.list.findIndex(x => x.maxDepth === parseInt(product.maxDepth));
  if (product.selected) {
    for (let i = 0; i < depthIndex + 1; i++) {
      pointStore.depths.list[i].disabled = false;
    }
    for (let i = depthIndex + 1; i < pointStore.depths.list.length; i++) {
      pointStore.depths.list[i].disabled = true;
      for (let j = 0; j < pointStore.selectedProducts.length; j++) {
        if (pointStore.selectedProducts[j] !== product) {
          if (pointStore.selectedProducts[j].maxDepth >= pointStore.depths.list[i].maxDepth) {
            pointStore.depths.list[i].disabled = false;
          }
        }
      }
    }
  } else {
    for (let i = depthIndex + 1; i < pointStore.depths.list.length; i++) {
      pointStore.depths.list[i].disabled = false;
    }
    for (let i = 0; i < pointStore.depths.list.length; i++) {
      for (let j = 0; j < pointStore.selectedProducts.length; j++) {
        if (pointStore.selectedProducts[j].maxDepth >= pointStore.depths.list[i].maxDepth) {
          pointStore.depths.list[i].disabled = false;
          break;
        } else {
          pointStore.depths.list[i].disabled = true;
        }
      }
    }
  }
}

function disableCategory(product) {
  if (product.selected) {
    for (let i = 0; i < pointStore.categories.list.length; i++) {
      var categoryIndex = product.categories.findIndex(x => x.id === pointStore.categories.list[i].id);
      if (categoryIndex < 0) {
        pointStore.categories.list[i].disabled = true;
        for (let j = 0; j < pointStore.selectedProducts.length; j++) {
          if (pointStore.selectedProducts[j] !== product) {
            categoryIndex = pointStore.selectedProducts[j].categories.findIndex(x => x.id === pointStore.categories.list[i].id);
            if (categoryIndex >= 0) {
              pointStore.categories.list[i].disabled = false;
            }
          }
        }
      } else {
        pointStore.categories.list[i].disabled = false;
      }
    }
  } else {
    for (let i = 0; i < pointStore.categories.list.length; i++) {
      var categoryIndex = product.categories.findIndex(x => x.id === pointStore.categories.list[i].id);
      let categoryExists = 0;
      if (categoryIndex < 0) {
        pointStore.categories.list[i].disabled = false;
      }
      for (let j = 0; j < pointStore.selectedProducts.length; j++) {
        categoryIndex = pointStore.selectedProducts[j].categories.findIndex(x => x.id === pointStore.categories.list[i].id);
        if (categoryIndex < 0) {
          categoryExists++;
        } else {
          categoryExists = 0;
          break;
        }
      }
      if (categoryExists > 0) {
        pointStore.categories.list[i].disabled = true;
      }
    }
  }
}

function disableProductByDepth(depth) {
  for (let i = 0; i < pointStore.products.list.length; i++) {
    if ((depth.selected && depth.maxDepth <= pointStore.products.list[i].maxDepth) ||
        (!depth.selected && pointStore.selectedCategories.length === 0 && pointStore.selectedDepths.length === 0)) {
      pointStore.products.list[i].disabled = false;
    } else {
      pointStore.products.list[i].disabled = true;
      for (let j = 0; j < pointStore.selectedDepths.length; j++) {
        if (pointStore.selectedDepths[j] !== depth && pointStore.selectedDepths[j].maxDepth <= pointStore.products.list[i].maxDepth) {
          pointStore.products.list[i].disabled = false;
          break;
        }
      }
      if (pointStore.products.list[i].disabled === true) {
        for (let k = 0; k < pointStore.selectedCategories.length; k++) {
          const productIndex = pointStore.products.list[i].categories.findIndex(x => x.id === pointStore.selectedCategories[k].id);
          if (productIndex >= 0) {
            pointStore.products.list[i].disabled = false;
            break;
          }
        }
      }
    }
  }
}

function disableProductByCategory(category) {
  for (let i = 0; i < pointStore.products.list.length; i++) {
    let productIndex = pointStore.products.list[i].categories.findIndex(x => x.id === category.id);
    if ((category.selected && productIndex >= 0) ||
        (!category.selected && pointStore.selectedCategories.length === 0 && pointStore.selectedDepths.length === 0)) {
      pointStore.products.list[i].disabled = false;
    } else {
      pointStore.products.list[i].disabled = true;
      for (let k = 0; k < pointStore.selectedCategories.length; k++) {
        productIndex = pointStore.products.list[i].categories.findIndex(x => x.id === pointStore.selectedCategories[k].id);
        if (pointStore.selectedCategories[k] !== category && productIndex >= 0) {
          pointStore.products.list[i].disabled = false;
          break;
        }
      }
      if (pointStore.products.list[i].disabled === true) {
        for (let j = 0; j < pointStore.selectedDepths.length; j++) {
          if (pointStore.selectedDepths[j].maxDepth <= pointStore.products.list[i].maxDepth) {
            pointStore.products.list[i].disabled = false;
            break;
          }
        }
      }
    }
  }
}

function marathon(point) {
  const pointIndex = pointStore.points.findIndex(x => x.articleNr === point.marathonLink);
  togglePoint(pointStore.points[pointIndex], true);
}

function togglePoint(point, marathon) {
  if (!point.disabled) {
    const scrollArea = document.getElementById('scroll-area');
    if (marathon) {
      for (let i = 0; i < pointStore.points.length; i++) {
        if (pointStore.points[i] !== point) {
          pointStore.points[i].selected = false;
        }
      }

      if (scrollArea.scrollWidth > window.outerWidth) {
        point.selected = true;
      } else {
        point.selected = true;
      }
    } else {
      point.selected = !point.selected;
    }
  }
}

function clearFilter() {
  for (let i = 0; i < pointStore.categories.list.length; i++) {
    pointStore.categories.list[i].selected = false;
    pointStore.categories.list[i].disabled = false;
  }
  for (let i = 0; i < pointStore.depths.list.length; i++) {
    pointStore.depths.list[i].selected = false;
    pointStore.depths.list[i].disabled = false;
  }
  for (let i = 0; i < pointStore.products.list.length; i++) {
    pointStore.products.list[i].selected = false;
    pointStore.products.list[i].disabled = false;
  }
  for (let i = 0; i < pointStore.points.length; i++) {
    pointStore.points[i].disabled = false;
  }
}

</script>